import { Pipe, PipeTransform } from '@angular/core';
import { Tappa } from '../models/tappa.model';
import { Tappe } from 'src/app/core';

@Pipe({
 name: 'tappacounter'
})

export class TappaCounterPipe implements PipeTransform {
    /**
     * si contano le tappe effettuate
     * @param  {any} data
     */
    transform(data: any): number {
        if (data == null) {
            return 0;
        }
        // console.log(data[0]);
        let counter = 0;
        data.forEach(tappa => {
            // console.log("tappa" + tappa);
            if (tappa) {
                        counter++;
                };
            }
        );
        return counter;
    }
}
